import axios from "../_helpers/axiosInstance.js";
import {authHeader} from "../_helpers/authHeader.js";


const getCustomerOrderDetails = async (orderId) => {
    const response = await axios.get(`customerOrder/${orderId}`, {headers: authHeader()});
    return response.data.result;
}
export const customerOrderApi = {
    getCustomerOrderDetails,
}
